import React from "react";
import tLogoImg from "../../Images/T-business-logo.png";
import posImg from "../../Images/pos-onboarding.png";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Page.css";

const PublicOnboadringInitialPage = () => {
  return (
    <div className="public-onboarding-initial__root">
      <div className="card container-fluid p-0 ">
        <div className="card-body">
          <img src={posImg} alt="POS uređaj" className="my-3" />
          <h1 className="my-3">
            Premium fiskalnu blagajnu aktivirate prvi put?
          </h1>
          <p className="my-3">
            (ako trenutno koristite Premium fiskalnu blagajnu ili ste ju nekada
            ranije koristili odaberite “NE”)
          </p>
          <div>
            <Link to="/public/onboarding">
              <Button className="mr-3">DA</Button>
            </Link>
            <Link to="/public/onboarding-existing">
              <Button className="ml-3">NE</Button>
            </Link>
          </div>
          <img src={tLogoImg} alt="T Business" className="mb-3 mt-4" />
        </div>
      </div>
    </div>
  );
};

export default PublicOnboadringInitialPage;
